<!--
作者：小明哥
模块：web首页
框架：VUE、vue-router、vuex、axios、ElementUI等
脚手架：VUE CLI3
-->
<template>
    <div id="app">
        <!--首页banner-->
        <home-banner></home-banner>
        <!--首页内容-->
        <div class="minheight">
            <video-knowledge-comm></video-knowledge-comm>
            <!-- 最新视频 -->
            <div style="text-align: center"><h2><br>最新课程</h2></div>
            <video-list-comm  params="?size=8"></video-list-comm>
            <!-- 推荐 -->
            <div style="text-align: center;margin-top: 15px;">
                <a href="/book/list" target="_blank">
                    <img src="../assets/img/home/vip.jpg" style="width: 1200px; border-radius: 5px;"/>
                </a>
                <h2><br>推荐课程</h2>
            </div>
            <!-- 推荐 组件 -->
            <video-recommend-comm :from-page="1" full-url="/web/webHomeRecommend/recommendList">
                <template><p class="header-class">优秀的学习资料，值得推荐</p></template>
            </video-recommend-comm>
            <!-- 学习引导 -->
            <div style="text-align: center;margin-top: 15px;">
                <h2><br>学习引导</h2>
            </div>
            <!-- 学习引导 组件 -->
            <home-type-video-comm v-for="(item,index) in courseTypeList" :course-type-item="item" :key="index">
                <template v-if="item.courseTypeName === '项目实战'" slot="gg">
                    <a href="/project/1" target="_blank" style="height: 290px; overflow: hidden;">
                        <img src="../assets/img/home/niudao-ky.png"/>
                    </a>
                </template>
            </home-type-video-comm>
        </div>
    </div>
</template>
<script>
    //banner
    import HomeBanner from '../components/HomeBanner'
    //知道点
    import VideoKnowledgeComm from '../components/VideoKnowledgeComm'
    //普通列表
    import VideoListComm from '../components/VideoListComm'
    //推荐
    import VideoRecommendComm from '../components/VideoRecommendComm'
    //按分类显示
    import HomeTypeVideoComm from '../components/HomeTypeVideoComm'

    export default {
        name: 'Home',
        data() {
            return {
                url: "/web/courseType",
                courseTypeList: null
            }
        },
        components: {
            HomeBanner,
            VideoKnowledgeComm,
            VideoListComm,
            VideoRecommendComm,
            HomeTypeVideoComm
        },
        async created() {
             this.courseTypeList = await this.$getItem(this.comm.LOCAL_KEY_COURSE_TYPE)
        }
    }
</script>
